import { ClientAuth, Logger } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { Menu } from '@/widgets/menu';
import { MyProfile } from '@/widgets/my-profile';
import { useEffect } from 'react';

export const ProfilePage = () => {
  const router = useRouter();

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  useEffect(() => {
    Logger.homeMy();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <Menu />
      <MyProfile />
    </div>
  );
};
